export default __webpack_public_path__ + "3e0f5ed1bb851e0ea9c2bb2ed9e96ff4.png";